import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('aricControllers')
        .factory('aricService', service);

    service.$inject = ['$http', '$q', 'env'];

    function service($http, $q, env) {
        var baseUrl = environment.apiUrl + '/Pilot/api/ARIC';

        var service = {
            getControlToAssess:               getControlToAssess,
            getDecisionForLevelOfTesting:     getDecisionForLevelOfTesting,
            sendReminderToCertificationOwner: sendReminderToCertificationOwner,
            unlockCertificationForOwner:      unlockCertificationForOwner,
        };
        return service;

        ////////////

        // Get control to assess
        function getControlToAssess(controlId) {
            var reqUrl = baseUrl + '/Control/' + controlId + '/Assessment';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        }

        function getDecisionForLevelOfTesting(controlId) {
            var reqUrl = baseUrl + '/Control/' + controlId + '/LevelOfTesting/Decision';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        }

        function sendReminderToCertificationOwner(controlOwner) {
            var reqUrl = baseUrl + '/Certification/Control/ByOwner/' + controlOwner.ItemPersonID + '/SendReminder';
            var isDebug = env.isDev || undefined;

            return $http.post(reqUrl, { isDebug: isDebug, controlOwner: controlOwner })
                        .then(function (response) {
                            return response.data;
                        });
        }

        function unlockCertificationForOwner(controlOwner) {
            var reqUrl = baseUrl + '/Certification/Control/ByOwner/' + controlOwner.ItemPersonID + '/Unlock';

            return $http.post(reqUrl, controlOwner )
                        .then(function (response) {
                            return response.data;
                        });
        }
    }
})();
